import Icon from '../components/Icon.vue'

Icon.register({
  'shopping-basket': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M576 216V232C576 245.3 565.3 256 552 256H544L517.9 438.8C514.5 462.4 494.3 480 470.4 480H105.6C81.7 480 61.5 462.4 58.1 438.8L32 256H24C10.7 256 0 245.3 0 232V216C0 202.7 10.7 192 24 192H91.3L198.1 45.2C208.5 30.9 228.5 27.7 242.8 38.1 257.1 48.5 260.3 68.5 249.9 82.8L170.5 192H405.5L326.1 82.8C315.7 68.5 318.9 48.5 333.2 38.1 347.5 27.7 367.5 30.9 377.9 45.2L484.7 192H552C565.3 192 576 202.7 576 216zM312 392V280C312 266.7 301.3 256 288 256S264 266.7 264 280V392C264 405.3 274.7 416 288 416S312 405.3 312 392zM424 392V280C424 266.7 413.3 256 400 256S376 266.7 376 280V392C376 405.3 386.7 416 400 416S424 405.3 424 392zM200 392V280C200 266.7 189.3 256 176 256S152 266.7 152 280V392C152 405.3 162.7 416 176 416S200 405.3 200 392z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/shopping-basket.js
// module id = dNSv
// module chunks = 144